export default __webpack_public_path__ + "static/media/ic_klp_24.5609bff3.svg";